"use client";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import Rating from "@/custom/Rating";
import { useToast } from "@/hooks/use-toast";
import { trimText } from "@/lib/trimText";
import { addReview } from "@/utils/action/data";
import { Star } from "lucide-react";
import { useState } from "react";

const AddReview = ({ product, userData }) => {
  const { success, warning } = useToast();
  const [currentValue, setCurrentValue] = useState(0);
  const [hoverValue, setHoverValue] = useState(0);
  const [comment, setComment] = useState("");

  const handleReview = async (e) => {
    e.preventDefault();

    if (currentValue < 1) {
      return warning("Please give a rating of at least 1");
    }

    const reviewData = {
      rating: currentValue,
      comment: comment || "",
      userName: userData?.name,
      userId: userData?._id,
      userImage: userData?.image,
      productId: product?._id,
      product: product,
    };

    const data = await addReview(reviewData);

    if (data?.success) {
      success("Review Added. Please wait until verify");
      setCurrentValue(0);
      setHoverValue(0);
      setComment("");
    }
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          className="border-brand-sky text-brand-deep hover:bg-brand-sky hover:text-white transition-colors rounded-xl font-semibold"
        >
          <Star size={16} className="mr-1.5" />
          Add Review
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px] rounded-2xl border-brand-light shadow-brand-lg">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-brand-navy">
            Add Ratings and Reviews for {trimText(product?.title, 60)}
          </DialogTitle>
          <DialogDescription className="text-muted-foreground">
            You can add your ratings and reviews. After finishing, click submit.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleReview}>
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1.5">
              <h1 className="text-base font-medium text-brand-navy">Rating</h1>
              <Rating
                currentValue={currentValue}
                setCurrentValue={setCurrentValue}
                hoverValue={hoverValue}
                setHoverValue={setHoverValue}
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <h1 className="text-base font-medium text-brand-navy">Comment</h1>
              <Textarea
                name="comment"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="col-span-3 border-brand-light focus:border-brand-sky focus:ring-2 focus:ring-brand-sky/20 rounded-xl transition-all"
              />
            </div>
          </div>
          <DialogClose asChild>
            <Button
              type="submit"
              className="mt-3 gradient-primary hover:opacity-95 text-white font-semibold rounded-xl shadow-brand hover:shadow-brand-lg transition-all px-6"
            >
              Submit
            </Button>
          </DialogClose>
        </form>
        <DialogFooter></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddReview;